import styled from 'styled-components';
import DepositIconDark from '../../assets/images/money-deposit-icon.svg';
import DepositIconLight from '../../assets/images/money-deposit-icon-light.svg';

const DepositMoneyIcon = styled.span`
  background: ${(props) =>
    props.theme.palette.type === 'dark'
      ? `url("${DepositIconDark}") no-repeat left center`
      : `url("${DepositIconLight}") no-repeat left center`};
  background-size: 34px 27px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  height: 27px;
  width: 34px;
`;

export default DepositMoneyIcon;
